import React from 'react';

const MiniCartButton = ({ handleClick, open, itemCount }) => {
  return (
    <button type="button" className="Button" data-style="text" onClick={() => handleClick(!open)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="500"
        height="500"
        viewBox="0 0 500 500"
        className="icon icon--primary"
        aria-controls="miniCartDrawer"
        aria-haspopup="true"
        tabIndex="true"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="currentColor" fillRule="nonzero">
            <path d="M270.996785,100.444444 L218.327974,100.444444 L218.327974,77.3333333 C218.327974,34.6666667 183.215434,0 140,0 C96.7845659,0 61.6720257,34.6666667 61.6720257,77.3333333 L61.6720257,100.444444 L9.00321543,100.444444 C4.05144695,100.444444 0,104.444444 0,109.333333 L0,391.111111 C0,396 4.05144695,400 9.00321543,400 L270.996785,400 C275.948553,400 280,396 280,391.111111 L280,109.333333 C280,104.444444 275.948553,100.444444 270.996785,100.444444 Z M79.6784566,77.3333333 C79.6784566,44.4444444 106.688103,17.7777778 140,17.7777778 C173.311897,17.7777778 200.321543,44.4444444 200.321543,77.3333333 L200.321543,100.444444 L79.6784566,100.444444 L79.6784566,77.3333333 Z M261.993569,382.222222 L18.0064309,382.222222 L18.0064309,118.222222 L61.6720257,118.222222 L61.6720257,136.444444 C61.6720257,141.333333 65.7234727,145.333333 70.6752412,145.333333 C75.6270096,145.333333 79.6784566,141.333333 79.6784566,136.444444 L79.6784566,118.222222 L200.321543,118.222222 L200.321543,136.444444 C200.321543,141.333333 204.37299,145.333333 209.324759,145.333333 C214.276527,145.333333 218.327974,141.333333 218.327974,136.444444 L218.327974,118.222222 L261.993569,118.222222 L261.993569,382.222222 Z" transform="translate(107 54)"/>
          </g>
        </g>
      </svg>
      {itemCount > 0 ? <span className="itemCount">{itemCount}</span> : null}
      <span className="screen-reader-text">Cart</span>
    </button>
    // <button
    //   className="Button Button--minicart"
    //   data-layout="noLayout"
    //   onClick={() => handleClick(!open)}
    //   aria-controls="miniCartDrawer"
    //   aria-haspopup="true"
    // >
    //   {/* {itemCount > 0 && (
    //     <span className="counter">
    //       <span>{itemCount}</span>
    //     </span>
    //   )} */}
    // </button>
  );
};

export default MiniCartButton;
